import { settingsSchema } from './chunk-GU4P4QPI.mjs';
import { getSettingsGenericError } from './chunk-TDNRUBPG.mjs';
import { selectGeneralSettingsTranslationPath, selectCurrentTimeZone } from './chunk-PHOCK55S.mjs';
import { i18n_config_default } from './chunk-SGCJ7UYI.mjs';
import { __async } from './chunk-T36PI2YV.mjs';
import { DateTime } from 'luxon';
import * as yup from 'yup';

var validateEndOfBusinessDay = (time, field = "endOfBusinessDay") => {
  const isValid = DateTime.fromISO(time).isValid;
  if (!time || !isValid) {
    return {
      message: JSON.stringify(
        getSettingsGenericError({
          key: field,
          id: field,
          message: i18n_config_default.t(
            `settingsModule.generalSettings.errors.organizationInformation.endOfBusinessDay.${!time ? "empty" : "invalid"}`
          ),
          section: "hoursOfOperation" /* HOURS_OF_OPERATION */
        })
      ),
      success: false,
      reason: !time ? "empty" : "invalid"
    };
  }
  return { success: true, message: "", reason: "" };
};
var generalSettingsSchema = (data, state) => __async(void 0, null, function* () {
  const locationPath = selectGeneralSettingsTranslationPath(state);
  const timeZone = selectCurrentTimeZone(state);
  return yield yup.object().shape({
    name: yup.string().trim().required(
      JSON.stringify(
        getSettingsGenericError({
          key: "name",
          id: "name",
          message: i18n_config_default.t(
            `settingsModule.generalSettings.errors.organizationInformation.name.${locationPath}`
          ),
          section: "organizationInformation" /* ORGANIZATION_INFORMATION */
        })
      )
    ),
    endOfBusinessDay: yup.string().trim().required(
      JSON.stringify(
        getSettingsGenericError({
          key: "endOfBusinessDay",
          id: "endOfBusinessDay",
          message: i18n_config_default.t(
            "settingsModule.generalSettings.errors.organizationInformation.endOfBusinessDay.empty"
          ),
          section: "hoursOfOperation" /* HOURS_OF_OPERATION */
        })
      )
    ).test("end-of-business-day-test", "", function(endOfBusinessDay) {
      const { success, message } = validateEndOfBusinessDay(endOfBusinessDay);
      if (!success) {
        return this.createError({
          message
        });
      }
      return true;
    }),
    websiteUrl: yup.string().nullable().notRequired().matches(
      /^$|^((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
      JSON.stringify(
        getSettingsGenericError({
          key: "websiteUrl",
          id: "websiteUrl",
          message: i18n_config_default.t(
            `settingsModule.generalSettings.errors.organizationInformation.websiteUrl.invalid.${locationPath}`
          ),
          section: "organizationInformation" /* ORGANIZATION_INFORMATION */
        })
      )
    ).trim(),
    phoneNumber: yup.string().trim().transform((value) => value === "" ? null : value).nullable().notRequired().min(
      10,
      JSON.stringify(
        getSettingsGenericError({
          key: "phoneNumber",
          id: "phoneNumber",
          message: i18n_config_default.t("validations.invalidPhoneNumber"),
          section: "basic" /* BASIC */
        })
      )
    ),
    postalCode: yup.string().trim().notRequired().test("menu-type-range-validation", "", function(postalCode) {
      if (postalCode && (postalCode == null ? void 0 : postalCode.length) !== 5) {
        return this.createError({
          message: JSON.stringify(
            getSettingsGenericError({
              key: "postalCode",
              id: "postalCode",
              message: i18n_config_default.t(
                "settingsModule.generalSettings.errors.organizationInformation.postalCode.invalid"
              ),
              section: "organizationInformation" /* ORGANIZATION_INFORMATION */
            })
          )
        });
      }
      return true;
    }),
    operationalDayHours: settingsSchema(
      () => JSON.stringify(
        getSettingsGenericError({
          key: "operationalDayHours",
          id: "operationalDayHours",
          message: i18n_config_default.t(
            "settingsModule.generalSettings.errors.operationalDayHours"
          ),
          section: "hoursOfOperation" /* HOURS_OF_OPERATION */
        })
      ),
      timeZone
    )
  }).validate(data, {
    abortEarly: false
  });
});

export { generalSettingsSchema, validateEndOfBusinessDay };
